const ALPHABET =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

export function generatePassword(length = 24): string {
  if (length <= 0) {
    return "";
  }

  const limit = Math.floor(256 / ALPHABET.length) * ALPHABET.length;
  const chars: string[] = [];

  while (chars.length < length) {
    const bytes = crypto.getRandomValues(new Uint8Array(length));
    for (let index = 0; index < bytes.length; index += 1) {
      const byte = bytes[index];
      if (byte < limit) {
        chars.push(ALPHABET[byte % ALPHABET.length]);
        if (chars.length === length) {
          break;
        }
      }
    }
  }

  return chars.join("");
}
